<template>
  <div class="supplyOfGoods w1400">
    <div class="supplyOfGoods-title font20">
      当前位置：车货配载 > 订单信息
    </div>
    <div class="supplyOfGoods-cont">
      <div class="table-title cont-odd font20">
        <div style="width: 200px;">订单日期</div>
        <div style="width: 500px;">货物名称</div>
        <div style="width: 600px;">收货地址</div>
      </div>
      <div :class="[i%2==0?'table-item cont-even':'table-item cont-odd']" v-for="(item,i) in tableData">
        <div class="table-title font16">
          <div style="width: 200px;">{{item.field1}}</div>
          <div style="width: 500px;text-align: left;">{{item.field2}}</div>
          <div style="width: 600px;text-align: left;">{{item.field3}}</div>
          <!-- <div @click="openInf(i)" class="cus">展开</div> -->
        </div>
        <!-- <div class="ele-table font16" v-show="item.falg">
          <table>
            <tr>
              <td class="tdw14">货物名称</td>
              <td class="tdw14">{{item.lc008}}</td>
              <td class="tdw7">重量</td>
              <td class="tdw7">{{item.lc009}}</td>
              <td class="tdw14">体积</td>
              <td class="tdw14">{{item.lc010}}</td>
              <td class="tdw14">发布时间</td>
              <td class="tdw21">{{item.lc011 | formatTime}}</td>
              <td class="tdw14">联系方式</td>
              <td class="tdw21">{{item.lc001}}</td>
            </tr>
            <tr>
              <td>起始地点</td>
              <td colspan="4">{{item.lc002}}</td>
              <td>到货地点</td>
              <td colspan="4">{{item.lc004}}</td>
            </tr>
          </table>
        </div> -->
      </div>
    </div>

   <!-- 2024-10-28号备份
<div class="supplyOfGoods-cont">
      <div class="table-title cont-odd font20">
        <div>货物名称</div>
        <div>货物重量(吨)</div>
        <div>起始地点</div>
        <div>到货地点</div>
        <div>发布时间</div>
        <div>操作</div>
      </div>
      <div :class="[i%2==0?'table-item cont-even':'table-item cont-odd']" v-for="(item,i) in tableData">
        <div class="table-title font16">
          <div>{{item.lc008}}</div>
          <div>{{item.lc009}}</div>
          <div>{{item.lc002}}</div>
          <div>{{item.lc004}}</div>
          <div>{{item.lc011 | formatTime}}</div>
          <div @click="openInf(i)" class="cus">展开</div>
        </div>
        <div class="ele-table font16" v-show="item.falg">
          <table>
            <tr>
              <td class="tdw14">货物名称</td>
              <td class="tdw14">{{item.lc008}}</td>
              <td class="tdw7">重量</td>
              <td class="tdw7">{{item.lc009}}</td>
              <td class="tdw14">体积</td>
              <td class="tdw14">{{item.lc010}}</td>
              <td class="tdw14">发布时间</td>
              <td class="tdw21">{{item.lc011 | formatTime}}</td>
              <td class="tdw14">联系方式</td>
              <td class="tdw21">{{item.lc001}}</td>
            </tr>
            <tr>
              <td>起始地点</td>
              <td colspan="4">{{item.lc002}}</td>
              <td>到货地点</td>
              <td colspan="4">{{item.lc004}}</td>
              <td>收货电话</td>
              <td colspan="2">{{item.phone}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    -->
    <div class="page">
       <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="currentPage"
             :page-sizes="[10, 20, 30, 40]"
             :page-size="pageSize"
             layout="sizes, prev, pager, next, jumper"
             :total="count">
           </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
          tableData:[],
          currentPage:1,
          pageSize:10,
          count:100,
      }
    },
    created() {
      this.getSupplyData()
    },
    methods:{
      openInf(i){
            this.tableData.forEach((ele,j)=>{
              if(ele.falg){
                ele.falg = !ele.falg;
                this.$set(this.tableData,j,ele)
              }else if(j==i){
                ele.falg = !ele.falg;
                this.$set(this.tableData,j,ele)
              }
            })
      },
      getSupplyData(){
        this.$axios.post('/api/shippingInfo/getMallOrderList',{
          skip:(this.currentPage-1)*this.pageSize,
          pageSize:this.pageSize
        }).then(res=>{
            this.tableData = res.data.data;
            this.count = res.data.count
        })
      },
      // getSupplyData(){
      //   this.$axios.post('/api/shippingInfo/list',{
      //     skip:(this.currentPage-1)*this.pageSize,
      //     pageSize:this.pageSize
      //   }).then(res=>{
      //       this.tableData = res.data.data;
      //       this.count = res.data.count
      //   })
      // },
      handleSizeChange(val){
        this.pageSize = val;
        this.getSupplyData()
      },
      handleCurrentChange(val){
        this.currentPage = val;
        this.getSupplyData();
      }
    },
  }
</script>

<style scoped>
  .supplyOfGoods{
    position: relative;
   padding-bottom: 9.4rem;
   min-height: 80rem;
  }
  .supplyOfGoods-title {
    box-sizing: border-box;
    height: 7rem;
    line-height: 7rem;
    padding-left: 2.7rem;
    background-color: #F6F5F5;
  }

  .supplyOfGoods-cont {
    overflow: hidden;
    width: 100%;
  }

  .table-title {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    align-items: center;
    text-align: center;
    height: 6rem;
    width: 100%;
  }

  .cont-even {
    background-color: #ECECEC;
  }

  .cont-odd {
    background-color: #F8F8F8;
  }
  .ele-table{
    padding-bottom: 1.5rem;
  }
  .cus{
    cursor: pointer;
  }
  table {
    border-collapse: collapse;
    text-align: center;
  }
  td{
     border: 1px solid black;
     height: 4.8rem;
  }
  .tdw7 {
    width: 7rem;

  }
  .tdw14{
     width: 14rem;
  }
  .tdw21{
    width: 21rem;
  }
  .page{
   position: absolute;
    bottom: 3.8rem;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/page/supplyOfGoods.vue